import React from 'react';
export function renderNamedSlot(Component, props) {
    const ValidComponent = Component;
    return Component ? (React.isValidElement(Component) ? (Component) : (React.createElement(ValidComponent, { ...props }))) : null;
}
